<div class="home-page">

  <div class="home-page__bg" aria-hidden="true"></div>

  <div class="home-card">

    <div class="home-card__logo-wrap">
      <img
        src="./assets/logo.webp"
        alt="Varever"
        class="home-card__logo">
    </div>

    <p class="home-card__eyebrow">Plataforma de certificación</p>
    <h1 class="home-card__title">Examen de certificación</h1>
    <p class="home-card__subtitle">
      Ingresa tu folio o ID de certificado para iniciar tu examen.
    </p>

    <form
      [formGroup]="formSearch"
      (ngSubmit)="onSubmit()"
      id="formSearch"
      class="home-card__form">

      <div class="home-field">
        <label class="home-field__label" for="idOrFolio">
          Folio o ID de certificado
        </label>
        <input
          id="idOrFolio"
          type="text"
          class="home-field__input"
          [class.home-field__input--error]="submitted && formControls['idOrFolio'].errors"
          formControlName="idOrFolio"
          placeholder="Ej. CERT-2024-001"
          autocomplete="off"
          spellcheck="false">

        @if(submitted && formControls['idOrFolio'].errors) {
          <p class="home-field__error" role="alert">
            @if(formControls['idOrFolio'].errors['required']) {
              Por favor ingresa un folio o ID de certificado.
            }
          </p>
        }
        @if(errorMessage) {
          <p class="home-field__error" role="alert">{{ errorMessage }}</p>
        }
      </div>

      <button
        class="home-btn"
        type="submit"
        form="formSearch"
        [disabled]="spinnerService.loading">
        @if(spinnerService.loading) {
          <span class="home-btn__spinner" role="status" aria-hidden="true"></span>
          Buscando...
        } @else {
          Buscar examen
        }
      </button>

    </form>

  </div>

</div>
